import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, useId } from 'react';
import { useFormContext } from 'react-hook-form';
import { checkboxStyles } from '../forms/shared-input-styles';

type Props = {
  name: string;
  className?: string;
  value?: string;
};

/**
 * @deprecated This component is deprecated. Go check out pm/ui MultiSelect
 */
export const HookFormCheckbox: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  name,
  className,
  value,
}) => {
  const { register } = useFormContext();
  const id = useId();

  return (
    <div className="flex items-center gap-4">
      <input
        {...register(name)}
        id={id}
        type="checkbox"
        className={clsx(checkboxStyles, className)}
        value={value}
      />
      <label htmlFor={id} className="text-grey-500">
        {children}
      </label>
    </div>
  );
};
